import React from 'react';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    // width: "100%",
    width: '35px',
    height: '35px',
    color: 'white',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'rgba(0, 0, 0, 0.38)',
    borderRadius: '50%',
    display: 'flex',
  },
  inactive: {
    background: 'rgba(0, 0, 0, 0.38)',
  },
  active: {
    background: '#056c93',
  },
  completed: {
    background: '#056c93',
  },
}));

const NumberStepIcon = (props) => {
  const {completed, active, icon} = props;
  const myClasses = useStyles();
  return (
    <>
      <div className={`${myClasses.root} ${completed?myClasses.completed :active?myClasses.active:myClasses.inactive}` } >
        {icon}
      </div>
    </>
  );
};

export default NumberStepIcon;
